export default Object.freeze({
    LANGUAGE_CODE: "language_code",
    URL: 'https://screencast.deskshare.com/wcapi',
    TOKEN: '_t',  
})